import React, { Component } from 'react';
import './App.css';
import EnqueteView from './EnqueteView'
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';

class App extends Component {
  
  render () {
    console.log('Router')
    return (
           <Router>
             <div>
             <Route path="/:id" component={EnqueteView} />
             </div>
           </Router>
                 );
  }
}
export default App;